import ApiService from './ApiService'
import appConfig from '../configs/app.config'


/*
{
  "user_name": "semih.ahishali",
  "password": "24474"
}
*/
export async function apiSignInDanone(data) {
    return ApiService.fetchData({
        url: appConfig.DANONEURL + 'login',
        method: 'post',
        headers: {
            'Content-Type': 'application/json',
            'client_type': 'web'
        },
        data
    })
}


/*
EXAMPLE RESPONSE  getCompetitionList
{
"Status": "Normal",
"Content":  {
        "customer_sap_code": "DN104406",
        "customer_name": "BAHÇELIEVLER IZMIR MMM MIGROS",
        "shelf_be_id": 1537784,
        "display_be_id": 1537789,
        "shelf_image_filenames": [
            {
                "file_name": "1754026082-DN104406-307-WA-1.jpg",
                "shoot_type": "Dolap Ici - Su"
            },
            {
                "file_name": "1754026091-DN104406-307-WA-2.jpg",
                "shoot_type": "Dolap Disi - Su"
            },
            {
                "file_name": "1754026101-DN104406-307-WA-3.jpg",
                "shoot_type": "Dolap Disi - Maden Suyu"
            }
        ],
        "display_image_filenames": [
            {
                "file_name": "1754026112-DN104406-307-WD-1.jpg",
                "shoot_type": "Maden Suyu"
            },
            {
                "file_name": "1754026119-DN104406-307-WD-2.jpg",
                "shoot_type": "Maden Suyu"
            }
        ],
        "date_time": "2025-08-01 08:29:43.305830",
        "user_id": 307,
        "user_name": "Nazan Karanfil",
        "sla_be_id": 1537790,
        "competition": true,
        "idx": 1,
        "shelf_products": {
            "1": {
                "File_Name": "1754026082-DN104406-307-WA-1.jpg",
                "file_inference_output": {
                    "1": {
                        "sap_code": "32737",
                        "label": "HAYAT-SPORCU-PET-750ML",
                        "y_min": 531,
                        "x_min": 595,
                        "y_max": 895,
                        "x_max": 704,
                        "migros_sap_code": null,
                        "c4_sap_code": null
                    },
                    "2": {
                        "sap_code": "32737",
                        "label": "HAYAT-SPORCU-PET-750ML",
                        "y_min": 532,
                        "x_min": 704,
                        "y_max": 891,
                        "x_max": 812,
                        "migros_sap_code": null,
                        "c4_sap_code": null
                    },
                    "3": {
                        "sap_code": "32738",
                        "label": "HAYAT-BEBEK-PET-6*330ML",
                        "y_min": 684,
                        "x_min": 216,
                        "y_max": 899,
                        "x_max": 496,
                        "migros_sap_code": null,
                        "c4_sap_code": null
                    },
                    "4": {
                        "sap_code": "32738",
                        "label": "HAYAT-BEBEK-PET-6*330ML",
                        "y_min": 472,
                        "x_min": 206,
                        "y_max": 690,
                        "x_max": 496,
                        "migros_sap_code": null,
                        "c4_sap_code": null
                    },
                    "5": {
                        "sap_code": "32737",
                        "label": "HAYAT-SPORCU-PET-750ML",
                        "y_min": 533,
                        "x_min": 492,
                        "y_max": 893,
                        "x_max": 594,
                        "migros_sap_code": null,
                        "c4_sap_code": null
                    },
                    "6": {
                        "sap_code": "32737",
                        "label": "HAYAT-SPORCU-PET-750ML",
                        "y_min": 526,
                        "x_min": 810,
                        "y_max": 893,
                        "x_max": 921,
                        "migros_sap_code": null,
                        "c4_sap_code": null
                    },
                    "7": {
                        "sap_code": "9999",
                        "label": "O-SAKA-PET-500ML",
                        "y_min": 615,
                        "x_min": 124,
                        "y_max": 901,
                        "x_max": 214,
                        "migros_sap_code": null,
                        "c4_sap_code": null
                    },
                    "8": {
                        "sap_code": "9999",
                        "label": "O-SAKA-PET-500ML",
                        "y_min": 616,
                        "x_min": 42,
                        "y_max": 898,
                        "x_max": 123,
                        "migros_sap_code": null,
                        "c4_sap_code": null
                    },
                    "12": {
                        "sap_code": "9999",
                        "label": "O-SAKA-PET-500ML",
                        "y_min": 40,
                        "x_min": 607,
                        "y_max": 289,
                        "x_max": 694,
                        "migros_sap_code": null,
                        "c4_sap_code": null
                    }
                }
            },
            "2": {
                "File_Name": "1754026091-DN104406-307-WA-2.jpg",
                "file_inference_output": {
                    "1": {
                        "sap_code": "32737",
                        "label": "HAYAT-SPORCU-PET-750ML",
                        "y_min": 531,
                        "x_min": 595,
                        "y_max": 895,
                        "x_max": 704,
                        "migros_sap_code": null,
                        "c4_sap_code": null
                    },
                    "2": {
                        "sap_code": "32737",
                        "label": "HAYAT-SPORCU-PET-750ML",
                        "y_min": 532,
                        "x_min": 704,
                        "y_max": 891,
                        "x_max": 812,
                        "migros_sap_code": null,
                        "c4_sap_code": null
                    },
                    "3": {
                        "sap_code": "32738",
                        "label": "HAYAT-BEBEK-PET-6*330ML",
                        "y_min": 684,
                        "x_min": 216,
                        "y_max": 899,
                        "x_max": 496,
                        "migros_sap_code": null,
                        "c4_sap_code": null
                    },
                    "4": {
                        "sap_code": "32738",
                        "label": "HAYAT-BEBEK-PET-6*330ML",
                        "y_min": 472,
                        "x_min": 206,
                        "y_max": 690,
                        "x_max": 496,
                        "migros_sap_code": null,
                        "c4_sap_code": null
                    },
                    "5": {
                        "sap_code": "32737",
                        "label": "HAYAT-SPORCU-PET-750ML",
                        "y_min": 533,
                        "x_min": 492,
                        "y_max": 893,
                        "x_max": 594,
                        "migros_sap_code": null,
                        "c4_sap_code": null
                    },
                    "6": {
                        "sap_code": "32737",
                        "label": "HAYAT-SPORCU-PET-750ML",
                        "y_min": 526,
                        "x_min": 810,
                        "y_max": 893,
                        "x_max": 921,
                        "migros_sap_code": null,
                        "c4_sap_code": null
                    },
                    "7": {
                        "sap_code": "9999",
                        "label": "O-SAKA-PET-500ML",
                        "y_min": 615,
                        "x_min": 124,
                        "y_max": 901,
                        "x_max": 214,
                        "migros_sap_code": null,
                        "c4_sap_code": null
                    },
                    "8": {
                        "sap_code": "9999",
                        "label": "O-SAKA-PET-500ML",
                        "y_min": 616,
                        "x_min": 42,
                        "y_max": 898,
                        "x_max": 123,
                        "migros_sap_code": null,
                        "c4_sap_code": null
                    },
                    "12": {
                        "sap_code": "9999",
                        "label": "O-SAKA-PET-500ML",
                        "y_min": 40,
                        "x_min": 607,
                        "y_max": 289,
                        "x_max": 694,
                        "migros_sap_code": null,
                        "c4_sap_code": null
                    }
                }
            },
            "3": {
                "File_Name": "1754026101-DN104406-307-WA-3.jpg",
                "file_inference_output": {
                    "1": {
                        "sap_code": "32737",
                        "label": "HAYAT-SPORCU-PET-750ML",
                        "y_min": 531,
                        "x_min": 595,
                        "y_max": 895,
                        "x_max": 704,
                        "migros_sap_code": null,
                        "c4_sap_code": null
                    },
                    "2": {
                        "sap_code": "32737",
                        "label": "HAYAT-SPORCU-PET-750ML",
                        "y_min": 532,
                        "x_min": 704,
                        "y_max": 891,
                        "x_max": 812,
                        "migros_sap_code": null,
                        "c4_sap_code": null
                    },
                    "3": {
                        "sap_code": "32738",
                        "label": "HAYAT-BEBEK-PET-6*330ML",
                        "y_min": 684,
                        "x_min": 216,
                        "y_max": 899,
                        "x_max": 496,
                        "migros_sap_code": null,
                        "c4_sap_code": null
                    },
                    "4": {
                        "sap_code": "32738",
                        "label": "HAYAT-BEBEK-PET-6*330ML",
                        "y_min": 472,
                        "x_min": 206,
                        "y_max": 690,
                        "x_max": 496,
                        "migros_sap_code": null,
                        "c4_sap_code": null
                    },
                    "5": {
                        "sap_code": "32737",
                        "label": "HAYAT-SPORCU-PET-750ML",
                        "y_min": 533,
                        "x_min": 492,
                        "y_max": 893,
                        "x_max": 594,
                        "migros_sap_code": null,
                        "c4_sap_code": null
                    },
                    "6": {
                        "sap_code": "32737",
                        "label": "HAYAT-SPORCU-PET-750ML",
                        "y_min": 526,
                        "x_min": 810,
                        "y_max": 893,
                        "x_max": 921,
                        "migros_sap_code": null,
                        "c4_sap_code": null
                    },
                    "7": {
                        "sap_code": "9999",
                        "label": "O-SAKA-PET-500ML",
                        "y_min": 615,
                        "x_min": 124,
                        "y_max": 901,
                        "x_max": 214,
                        "migros_sap_code": null,
                        "c4_sap_code": null
                    },
                    "8": {
                        "sap_code": "9999",
                        "label": "O-SAKA-PET-500ML",
                        "y_min": 616,
                        "x_min": 42,
                        "y_max": 898,
                        "x_max": 123,
                        "migros_sap_code": null,
                        "c4_sap_code": null
                    },
                    "12": {
                        "sap_code": "9999",
                        "label": "O-SAKA-PET-500ML",
                        "y_min": 40,
                        "x_min": 607,
                        "y_max": 289,
                        "x_max": 694,
                        "migros_sap_code": null,
                        "c4_sap_code": null
                    }
                }
            }
        },
        "display_products": {
            "1": {
                "File_Name": "1754026112-DN104406-307-WD-1.jpg",
                "file_inference_output": {}
            },
            "2": {
                "File_Name": "1754026119-DN104406-307-WD-2.jpg",
                "file_inference_output": {}
            }
        }
    },
}
*/
export async function getCompetitionList(data) {
    return ApiService.fetchData({
        url: appConfig.DANONEURL + 'getcompetitionlist',
        method: 'get',
        headers: {
            'Content-Type': 'application/json',
            'start_date': data.start_date,
            'end_date': data.end_date
        },
        data
    })
}

/*
Get competition questions for a specific competition
ÖRNEK RESPONSE
{
    "Status": "Normal",
    "Content": [
        {
            "q_type_id": 8,
            "question_type": "Planogram Uygunlu\u011fu",
            "questions": [
                {
                    "sequence_no": 1,
                    "question_text": "Ayni blok icerisinde t\u00fcm markalar temas halinde bulunmasa da, yukaridan asagida minimum 3 rafta activia markasi, minimum alt 3 rafta Kids, Yoshake, Danette \u00fcr\u00fcnleri konumlandinildi mi?\n",
                    "answer_type": "enum",
                    "answer_options": [
                        {
                            "id": 1,
                            "key": "Evet",
                            "point": 1,
                            "value": 1,
                            "maxCount": null,
                            "minCount": null
                        },
                        {
                            "id": 2,
                            "key": "Hay\u0131r",
                            "point": 0,
                            "value": 0,
                            "maxCount": null,
                            "minCount": null
                        }
                    ]
                },
                {
                    "sequence_no": 2,
                    "question_text": "T\u00fcm Activia \u00fcr\u00fcnlerinin temas halinde olmasi ve aralarina baska bir marka girsi olmadan rafta konumlandinilmasi saglandi mi?\n",
                    "answer_type": "enum",
                    "answer_options": [
                        {
                            "id": 1,
                            "key": "Evet",
                            "point": 1,
                            "value": 1,
                            "maxCount": null,
                            "minCount": null
                        },
                        {
                            "id": 2,
                            "key": "Hay\u0131r",
                            "point": 0,
                            "value": 0,
                            "maxCount": null,
                            "minCount": null
                        }
                    ]
                },
                {
                    "sequence_no": 3,
                    "question_text": "Activia 4*100 veya Big Cup veya 8*100 \u00fcr\u00fcnlerinin temas halinde ve yan yang bir b\u00fct\u00fcn olarak konumlandinilmasi saglandi mi?\n",
                    "answer_type": "enum",
                    "answer_options": [
                        {
                            "id": 1,
                            "key": "Evet",
                            "point": 1,
                            "value": 1,
                            "maxCount": null,
                            "minCount": null
                        },
                        {
                            "id": 2,
                            "key": "Hay\u0131r",
                            "point": 0,
                            "value": 0,
                            "maxCount": null,
                            "minCount": null
                        }
                    ]
                },
                {
                    "sequence_no": 4,
                    "question_text": "Activia Bowl veya Mix&Go veya Mix&Go MP \u00fcr\u00fcnlerinin temas ve yan yana halinde bir b\u00fct\u00fcn olarak konumlandirilmasi saglandi mi?\n",
                    "answer_type": "enum",
                    "answer_options": [
                        {
                            "id": 1,
                            "key": "Evet",
                            "point": 1,
                            "value": 1,
                            "maxCount": null,
                            "minCount": null
                        },
                        {
                            "id": 2,
                            "key": "Hay\u0131r",
                            "point": 0,
                            "value": 0,
                            "maxCount": null,
                            "minCount": null
                        }
                    ]
                },
                {
                    "sequence_no": 5,
                    "question_text": "Activia Shake veya Shot veya Shot MP \u00fcr\u00fcnlerinin temas halinde ve yan yana bir b\u00fct\u00fcn olarak konumlandinlmasi saglandi mi?\n",
                    "answer_type": "enum",
                    "answer_options": [
                        {
                            "id": 1,
                            "key": "Evet",
                            "point": 1,
                            "value": 1,
                            "maxCount": null,
                            "minCount": null
                        },
                        {
                            "id": 2,
                            "key": "Hay\u0131r",
                            "point": 0,
                            "value": 0,
                            "maxCount": null,
                            "minCount": null
                        }
                    ]
                },
                {
                    "sequence_no": 6,
                    "question_text": "Activia Spoonable \u00fcr\u00fcnleri i\u00e7in Kilavuzda belirtildigi sekilde \u00fcr\u00fcn stralamasina g\u00f6re yerlestirmeler yapildi mi? Eksik \u00fcr\u00fcn olsa bile \u00fcr\u00fcn\u00fcn cesidindeki siralama ayni olmali",
                    "answer_type": "enum",
                    "answer_options": [
                        {
                            "id": 1,
                            "key": "Evet",
                            "point": 1,
                            "value": 1,
                            "maxCount": null,
                            "minCount": null
                        },
                        {
                            "id": 2,
                            "key": "Hay\u0131r",
                            "point": 0,
                            "value": 0,
                            "maxCount": null,
                            "minCount": null
                        }
                    ]
                },
                {
                    "sequence_no": 7,
                    "question_text": "Activia Bowl \u00fcr\u00fcnleri icin Kilavuzda belirtildigi sekilde \u00fcr\u00fcn siralamasina g\u00f6re yerlestirmeler yapildi mi?\n",
                    "answer_type": "enum",
                    "answer_options": [
                        {
                            "id": 1,
                            "key": "Evet",
                            "point": 1,
                            "value": 1,
                            "maxCount": null,
                            "minCount": null
                        },
                        {
                            "id": 2,
                            "key": "Hay\u0131r",
                            "point": 0,
                            "value": 0,
                            "maxCount": null,
                            "minCount": null
                        }
                    ]
                },
                {
                    "sequence_no": 8,
                    "question_text": "Activia Shot \u00fcr\u00fcnleri icin Kilavuzda belirtildigi sekilde \u00fcr\u00fcn siralamasina g\u00f6re yerlestirmeler yapildi mi?\n",
                    "answer_type": "enum",
                    "answer_options": [
                        {
                            "id": 1,
                            "key": "Evet",
                            "point": 1,
                            "value": 1,
                            "maxCount": null,
                            "minCount": null
                        },
                        {
                            "id": 2,
                            "key": "Hay\u0131r",
                            "point": 0,
                            "value": 0,
                            "maxCount": null,
                            "minCount": null
                        }
                    ]
                },
                {
                    "sequence_no": 9,
                    "question_text": "Alpro \u00fcr\u00fcnleri i\u00e7in kilavuzda belirtildigi \u00fczere orijinal - sekersiz - aromali - 500 Ml - 250 ml seklinde kategori ayrimi vapildi mi?",
                    "answer_type": "enum",
                    "answer_options": [
                        {
                            "id": 1,
                            "key": "Evet",
                            "point": 1,
                            "value": 1,
                            "maxCount": null,
                            "minCount": null
                        },
                        {
                            "id": 2,
                            "key": "Hay\u0131r",
                            "point": 0,
                            "value": 0,
                            "maxCount": null,
                            "minCount": null
                        }
                    ]
                },
                {
                    "sequence_no": 10,
                    "question_text": "Alpro Orijinal \u00fcr\u00fcnleri i\u00e7in Kilavuzda belirtildigi sekilde \u00fcr\u00fcn siralamasina g\u00f6re yerlestirmeler yapildi mi?\n",
                    "answer_type": "enum",
                    "answer_options": [
                        {
                            "id": 1,
                            "key": "Evet",
                            "point": 1,
                            "value": 1,
                            "maxCount": null,
                            "minCount": null
                        },
                        {
                            "id": 2,
                            "key": "Hay\u0131r",
                            "point": 0,
                            "value": 0,
                            "maxCount": null,
                            "minCount": null
                        }
                    ]
                },
                {
                    "sequence_no": 11,
                    "question_text": "Alpro Sekersiz \u00fcr\u00fcnleri i\u00e7in Kilavuzda belirtildigi sekilde \u00fcr\u00fcn siralamasina g\u00f6re yerlestirmeler yapildi mi?\n",
                    "answer_type": "enum",
                    "answer_options": [
                        {
                            "id": 1,
                            "key": "Evet",
                            "point": 1,
                            "value": 1,
                            "maxCount": null,
                            "minCount": null
                        },
                        {
                            "id": 2,
                            "key": "Hay\u0131r",
                            "point": 0,
                            "value": 0,
                            "maxCount": null,
                            "minCount": null
                        }
                    ]
                },
                {
                    "sequence_no": 12,
                    "question_text": "Alpro Aromali \u00fcr\u00fcnleri i\u00e7in Kilavuzda belirtildigi sekilde \u00fcr\u00fcn siralamasina g\u00f6re yerlestirmeler yapildi mi?",
                    "answer_type": "enum",
                    "answer_options": [
                        {
                            "id": 1,
                            "key": "Evet",
                            "point": 1,
                            "value": 1,
                            "maxCount": null,
                            "minCount": null
                        },
                        {
                            "id": 2,
                            "key": "Hay\u0131r",
                            "point": 0,
                            "value": 0,
                            "maxCount": null,
                            "minCount": null
                        }
                    ]
                }
            ]
        },
        {
            "q_type_id": 9,
            "question_type": "\u0130kincil Sergileme(Te\u015fhir)",
            "questions": [
                {
                    "sequence_no": 1,
                    "question_text": "Herhangi (UHT+FRESH) bir kategoride minimum 6 \u00fcr\u00fcn olacak \u015fekilde yap\u0131lan te\u015fhir var m\u0131 ?",
                    "answer_type": "enum",
                    "answer_options": [
                        {
                            "id": 1,
                            "key": "Evet",
                            "point": 1,
                            "value": 1,
                            "maxCount": 5,
                            "minCount": 1
                        },
                        {
                            "id": 2,
                            "key": "Hay\u0131r",
                            "point": 0,
                            "value": 0,
                            "maxCount": null,
                            "minCount": null
                        }
                    ]
                },
                {
                    "sequence_no": 2,
                    "question_text": "Alpro markal\u0131 \u00fcr\u00fcnlerden minimum 6 \u00fcr\u00fcn olacak \u015fekilde te\u015fhir var m\u0131 ?",
                    "answer_type": "enum",
                    "answer_options": [
                        {
                            "id": 1,
                            "key": "Evet",
                            "point": 5,
                            "value": 1,
                            "maxCount": 1,
                            "minCount": 1
                        },
                        {
                            "id": 2,
                            "key": "Hay\u0131r",
                            "point": 0,
                            "value": 0,
                            "maxCount": null,
                            "minCount": null
                        }
                    ]
                },
                {
                    "sequence_no": 3,
                    "question_text": "Krema markal\u0131 \u00fcr\u00fcnlerden minimum 6 \u00fcr\u00fcn olacak \u015fekilde te\u015fhir var m\u0131 ?",
                    "answer_type": "enum",
                    "answer_options": [
                        {
                            "id": 1,
                            "key": "Evet",
                            "point": 5,
                            "value": 1,
                            "maxCount": 1,
                            "minCount": 1
                        },
                        {
                            "id": 2,
                            "key": "Hay\u0131r",
                            "point": 0,
                            "value": 0,
                            "maxCount": null,
                            "minCount": null
                        }
                    ]
                }
            ]
        },
        {
            "q_type_id": 10,
            "question_type": "POP Kullan\u0131m\u0131",
            "questions": [
                {
                    "sequence_no": 1,
                    "question_text": "So\u011futucu i\u00e7erisinde Activia Kategorisi Ye\u015fil Blok i\u00e7in POP Yerle\u015fimi var m\u0131 ?",
                    "answer_type": "enum",
                    "answer_options": [
                        {
                            "id": 1,
                            "key": "Evet",
                            "point": 1,
                            "value": 1,
                            "maxCount": 10,
                            "minCount": 2
                        },
                        {
                            "id": 2,
                            "key": "Hay\u0131r",
                            "point": 0,
                            "value": 0,
                            "maxCount": null,
                            "minCount": null
                        }
                    ]
                },
                {
                    "sequence_no": 2,
                    "question_text": "S\u00fct reyonunda Alpro Kategorisi i\u00e7in POP Yerle\u015fimi var m\u0131 ?",
                    "answer_type": "enum",
                    "answer_options": [
                        {
                            "id": 1,
                            "key": "Evet",
                            "point": 1,
                            "value": 1,
                            "maxCount": 10,
                            "minCount": 2
                        },
                        {
                            "id": 2,
                            "key": "Hay\u0131r",
                            "point": 0,
                            "value": 0,
                            "maxCount": null,
                            "minCount": null
                        }
                    ]
                },
                {
                    "sequence_no": 3,
                    "question_text": "So\u011futucu \u00e7evresinde Di\u011fer (YoShake) te\u015fhiri var m\u0131 ?",
                    "answer_type": "enum",
                    "answer_options": [
                        {
                            "id": 1,
                            "key": "Evet",
                            "point": 1,
                            "value": 1,
                            "maxCount": 2,
                            "minCount": 1
                        },
                        {
                            "id": 2,
                            "key": "Hay\u0131r",
                            "point": 0,
                            "value": 0,
                            "maxCount": null,
                            "minCount": null
                        }
                    ]
                }
            ]
        },
        {
            "q_type_id": 11,
            "question_type": "Fiyat Etiketi",
            "questions": [
                {
                    "sequence_no": 3,
                    "question_text": "T\u00fcm \u00fcr\u00fcnlerin fiyat etiketleri var m\u0131 ? Fiyat etiketi sku \u00e7e\u015fidi baz\u0131nda tekil kontrol edilmelidir. Rafta bulunan herhangi bir \u00e7e\u015fit skunun etiketi yok ise puan al\u0131namaz",
                    "answer_type": "enum",
                    "answer_options": [
                        {
                            "id": 1,
                            "key": "Evet",
                            "point": 2,
                            "value": 1,
                            "maxCount": null,
                            "minCount": null
                        },
                        {
                            "id": 2,
                            "key": "Hay\u0131r",
                            "point": 0,
                            "value": 0,
                            "maxCount": null,
                            "minCount": null
                        }
                    ]
                }
            ]
        }
    ]
}
*/
export async function getCompetitionQuestions(data) {
    return ApiService.fetchData({
        url: appConfig.DANONEURL + 'getcompetitionquestions',
        method: 'get',
        headers: { 'Content-Type': 'application/json' },
        data
    })
}

/*
Get image file - Updated to handle binary data properly
*/
export async function getImageFile(data) {
    return ApiService.fetchData({
        url: appConfig.DANONEURL + 'getimagefile/' + data.fileName.file_name,
        method: 'get',
        headers: { 'Content-Type': 'application/json' },
        responseType: 'arraybuffer', // Binary data için arraybuffer kullan
        data
    })
}

/*
Save competition answers

ÖRNEK REQUEST
{
    "customer_sap_code": "DN104406",
    "transaction_log_id": 1537790,
    "shelf_be_id": 1537784,
    "display_be_id": 1537789,
    "answers": 
        [
            {
                "q_type_id" : 8,
                "question_type": "Planogram Uygunluğu",
                "answers":
                [
                    {
                        "question_id": 1,
                        "brand": "Soğutucu",
                        "key": "Hayır",
                        "value": 0,
                        "count": 0,
                        "point": 0,
                        "note": "Reyon resmi tam olarak görülemiyor.",
                        "note_images": ["1754026082-DN104406-307-WA-1.jpg","1754026082-DN104406-307-WA-2.jpg"]
                    },
                    {
                        "question_id": 2,
                        "brand": "Soğutucu",
                        "key": "Hayır",
                        "value": 0,
                        "count": 0,
                        "point": 0,
                        "note": "Reyon resmi tam olarak görülemiyor.",
                        "note_images": ["1754026082-DN104406-307-WA-1.jpg","1754026082-DN104406-307-WA-2.jpg"]
                    },
                    {
                        "question_id": 3,
                        "brand": "Soğutucu",
                        "key": "Evet",
                        "value": 1,
                        "count": 0,
                        "point": 1,
                        "note": null,
                        "note_images": []
                    },
                    {
                        "question_id": 4,
                        "brand": "Soğutucu",
                        "key": "Evet",
                        "value": 1,
                        "count": 0,
                        "point": 1,
                        "note": null,
                        "note_images": []
                    },
                    {
                        "question_id": 5,
                        "brand": "Soğutucu",
                        "key": "Evet",
                        "value": 1,
                        "count": 0,
                        "point": 1,
                        "note": null,
                        "note_images": []
                    },
                    {
                        "question_id": 6,
                        "brand": "Soğutucu",
                        "key": "Evet",
                        "value": 1,
                        "count": 0,
                        "point": 1,
                        "note": null,
                        "note_images": []
                    },
                    {
                        "question_id": 7,
                        "brand": "Soğutucu",
                        "key": "Evet",
                        "value": 1,
                        "count": 0,
                        "point": 1,
                        "note": null,
                        "note_images": []
                    },
                    {
                        "question_id": 8,
                        "brand": "Soğutucu",
                        "key": "Evet",
                        "value": 1,
                        "count": 0,
                        "point": 1,
                        "note": null,
                        "note_images": []
                    },
                    {
                        "question_id": 9,
                        "brand": "Süt",
                        "key": "Hayır",
                        "value": 0,
                        "count": 0,
                        "point": 0,
                        "note": "Reyon resmi tam olarak görülemiyor.",
                        "note_images": ["1754026082-DN104406-307-WA-1.jpg","1754026082-DN104406-307-WA-2.jpg"]
                    },
                    {
                        "question_id": 10,
                        "brand": "Süt",
                        "key": "Evet",
                        "value": 1,
                        "count": 0,
                        "point": 1,
                        "note": null,
                        "note_images": []
                    },
                    {
                        "question_id": 11,
                        "brand": "Süt",
                        "key": "Evet",
                        "value": 1,
                        "count": 0,
                        "point": 1,
                        "note": null,
                        "note_images": []
                    },
                    {
                        "question_id": 12,
                        "brand": "Süt",
                        "key": "Evet",
                        "value": 1,
                        "count": 0,
                        "point": 1,
                        "note": null,
                        "note_images": []
                    }
                ]
            },
            {
                "q_type_id" : 9,
                "question_type": "İkincil Sergileme(Teşhir)",
                "answers":
                [
                    {
                        "question_id": 13,
                        "brand": "Teşhir",
                        "key": "Evet",
                        "value": 1,
                        "count": 3,
                        "point": 3,
                        "note": null,
                        "note_images": []
                    },
                    {
                        "question_id": 14,
                        "brand": "Teşhir",
                        "key": "Evet",
                        "value": 1,
                        "count": 1,
                        "point": 5,
                        "note": null,
                        "note_images": []
                    },
                    {
                        "question_id": 15,
                        "brand": "Teşhir",
                        "key": "Hayır",
                        "value": 0,
                        "count": 0,
                        "point": 0,
                        "note": "Teşhir Bulunamadı",
                        "note_images": ["1754026082-DN104406-307-WA-1.jpg","1754026082-DN104406-307-WA-2.jpg"]
                    }
                ]
            },
            {
                "q_type_id" : 10,
                "question_type": "POP Kullanımı",
                "answers":
                [
                    {
                        "question_id": 16,
                        "brand": "POP Kullanımı",
                        "key": "Evet",
                        "value": 1,
                        "count": 3,
                        "point": 1,
                        "note": null,
                        "note_images": []
                    },
                    {
                        "question_id": 17,
                        "brand": "POP Kullanımı",
                        "key": "Hayır",
                        "value": 0,
                        "count": 0,
                        "point": 0,
                        "note": "POP Bulunamadı",
                        "note_images": ["1754026082-DN104406-307-WA-1.jpg","1754026082-DN104406-307-WA-2.jpg"]
                    },
                    {
                        "question_id": 19,
                        "brand": "POP Kullanımı",
                        "key": "Evet",
                        "value": 1,
                        "count": 2,
                        "point": 1,
                        "note": null,
                        "note_images": []
                    }
                ]
            },
            {
                "q_type_id" : 11,
                "question_type": "Fiyat Etiketi",
                "answers":
                [
                    {
                        "question_id": 19,
                        "brand": "Fiyat Etiketi",
                        "key": "Evet",
                        "value": 1,
                        "count": 0,
                        "point": 2,
                        "note": null,
                        "note_images": []
                    }
                ]
            }

        ],
    "renew": false
}
*/
export async function saveCompetitionAnswers(data) {
    return ApiService.fetchData({
        url: appConfig.DANONEURL + 'savecompetitionanswers',
        method: 'post',
        headers: { 'Content-Type': 'application/json' },
        data
    })
}

/*
Check lock status for an image
Request: GET with transaction_log_id in headers
Response: {
    "is_locked": boolean,
    "can_edit": boolean,
    "locked_by": string (username),
    "locked_until": string (ISO datetime)
}
*/
export async function lockImageStatus(data) {
    return ApiService.fetchData({
        url: appConfig.DANONEURL + 'images/lock-status',
        method: 'get',
        headers: {
            'Content-Type': 'application/json',
            'transaction_log_id': data.transaction_log_id
        },
        data
    })
}

/*
Lock an image for editing (30 minutes default)
Request: POST with transaction_log_id
Response: {
    "success": boolean,
    "locked_until": string (ISO datetime),
    "message": string
}
*/
export async function lockImage(data) {
    return ApiService.fetchData({
        url: appConfig.DANONEURL + 'images/lock',
        method: 'post',
        headers: {
            'Content-Type': 'application/json',
            'transaction_log_id': data.transaction_log_id
        },
        data: {}
    })
}

/*
Unlock an image (remove lock)
Request: POST with transaction_log_id
Response: {
    "success": boolean,
    "message": string
}
*/
export async function unlockImage(data) {
    return ApiService.fetchData({
        url: appConfig.DANONEURL + 'images/unlock',
        method: 'post',
        headers: {
            'Content-Type': 'application/json',
            'transaction_log_id': data.transaction_log_id
        },
        data: {}
    })
}


/*
Unlock an image (remove lock)
Request: POST with transaction_log_id
Response: {
    "success": boolean,
    "message": string
}
*/
export async function getCompetitionDeprecation(data) {
    return ApiService.fetchData({
        url: appConfig.DANONEURL + 'getcompetitiondeprecation',
        method: 'get',
        headers: {
            'Content-Type': 'application/json',
            'start_date': data.start_date,
            'end_date': data.end_date
        },
        data: {}
    })
}

/*
Example request
{
    "id": 1,
    "transaction_log_id": 1698150,
    "shelf_be_id": 1698132,
    "display_be_id": 1698148,
    "status": "YENİDEN DEĞERLEME",
    "note": "Tekrar kontrol edilecek"
}

Example Response
{
    "Status": "Normal",
    "Content": "Update completed successfully in both DBs",
    "Message": "Competition result updated successfully"
}
*/
export async function updateCompetitionDeprecation(data) {
    return ApiService.fetchData({
        url: appConfig.DANONEURL + 'updatecompetitiondeprecation',
        method: 'post',
        headers: {
            'Content-Type': 'application/json'
        },
        data
    })
}

export async function getProducts() {
    return ApiService.fetchData({
        url: appConfig.DANONEURL + 'getproducts?project-name=Danone',
        method: 'get',
        headers: { 'Content-Type': 'application/json' }
    })
}

export async function getFileAnalyzeDetail(data) {
    return ApiService.fetchData({
        url: appConfig.DANONEURL + `getfileanalyzedetail?transaction_log_id=${data.transaction_log_id}&project-name=Danone&file_name=${data.file_name}`,
        method: 'get',
        headers: { 'Content-Type': 'application/json' }
    })
}

export async function saveFileAnalyzeDetail(data) {
    return ApiService.fetchData({
        url: appConfig.DANONEURL + 'savefileanalyzedetail',
        method: 'post',
        headers: { 'Content-Type': 'application/json' },
        data
    })
}

/*
Incentive listesi - survey_answers kayitlarini customer_sap_code'a gore gruplar
ÖRNEK RESPONSE
{
    "Status": "Normal",
    "Content": [
        {
            "customer_sap_code": "DN100136",
            "customer_name": "FENUĞURSAN (İHSAN...)",
            "sn_merch_ziyaret_segmenti": "A",
            "answer_count": 2,
            "answer_ids": [317738, 317912],
            "manual_control_status": false
        }
    ]
}
*/
export async function getIncentiveList(data) {
    return ApiService.fetchData({
        url: appConfig.DANONEURL + 'getincentivelist',
        method: 'get',
        headers: {
            'Content-Type': 'application/json',
            'start_date': data.start_date,
            'end_date': data.end_date
        },
        data
    })
}

/*
Tek survey_answers kaydinin answers + answer_manual_answers verisi
ÖRNEK RESPONSE
{
    "Status": "Normal",
    "Content": {
        "answer_id": 317738,
        "manual_control_status": false,
        "answers": [
            {
                "id": 25,
                "group_name": "Allesantral Kurulum",
                "question_text": "Var mı?",
                "question_type": "BOOLEAN",
                "answer": "True",
                "manual_answer": null
            }
        ]
    }
}
*/
export async function getAnswers(data) {
    return ApiService.fetchData({
        url: appConfig.DANONEURL + `getanswers?answer_id=${data.answer_id}`,
        method: 'get',
        headers: { 'Content-Type': 'application/json' }
    })
}

/*
Manuel cevaplari kaydeder. manual_answers icindeki id'ler getanswers cevabindaki
soru id'leri ile ayni olmalidir. Kullanici adi gonderilmez; token'dan alinir.
*/
export async function setSurveyAnswer(data) {
    return ApiService.fetchData({
        url: appConfig.DANONEURL + 'setsurveyanswer',
        method: 'post',
        headers: { 'Content-Type': 'application/json' },
        data
    })
}
